import { useSubscribeToPrivateWebsocketEvent } from '~/core/shared/contexts/websockets';
import { User } from '../../../../types';
import { buildUserChannelName } from '../../logic/buildUserChannelName';
import { UserPrivateWebsocketEvent } from '../../types/UserPrivateWebsocketEvent';
import { UserPrivateWebsocketEventPayload } from '../../types/UserPrivateWebsocketEventPayload';

export const useSubscribeToUserUpdated = (
  userId: User['id'],
  onUpdate: (
    payload: UserPrivateWebsocketEventPayload[UserPrivateWebsocketEvent.Updated],
  ) => void,
): void => {
  useSubscribeToPrivateWebsocketEvent(
    buildUserChannelName(userId),
    UserPrivateWebsocketEvent.Updated,
    onUpdate,
  );
};
